import { render, staticRenderFns } from "./buy.vue?vue&type=template&id=5c400d82&scoped=true&"
import script from "./buy.vue?vue&type=script&lang=js&"
export * from "./buy.vue?vue&type=script&lang=js&"
import style0 from "./buy.vue?vue&type=style&index=0&id=5c400d82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c400d82",
  null
  
)

export default component.exports